import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { MesnaZajednica } from './mesna-zajednica';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-mesna-zajednica-update',
  templateUrl: './mesna-zajednica-update.component.html'  
})
export class MesnaZajednicaUpdateComponent extends BaseUpdateComponent<MesnaZajednica> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'MESNAZAJEDNICA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(200), 'maxlength', 'MESNAZAJEDNICA.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("MestoID", Validators.required, 'required', 'MESNAZAJEDNICA.MESTOID.VALIDATION.REQUIRED');
  }

}
